import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Radio, parseSettingsToData } from '../../Components/Form';
import { useSettings } from '../../Data/Settings';

const Notifications = ({isOpen, setIsOpen, onSave}) => {
    return <Modal title="Marketplace Notifications" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner onSave={onSave} />}
    </Modal>
}

const Inner = ({onSave}) => {
    const {settings, update} = useSettings('/marketplace/settings', 'Notifications updated');

    return <div className="prose-sm">
        <p>
            You can choose to receive notifications when new leads are available.
        </p>

        <Form data={parseSettingsToData(settings)} waitForData onSubmit={update} afterSubmit={onSave} closeModalOnSubmit>
            <Radio name="Marketplace:MarketAvailableLeads"
                label="Notifications"
                layout="List"
                options={[
                    {
                        label: 'Nearby leads',
                        value: 'Nearby',
                    },
                    {
                        label: 'Only leads in my patch',
                        value: 'Patch',
                    },
                    {
                        label: 'Don\'t receive notifications',
                        value: 'None',
                    },
                ]}
            />
            <Actions submit={{label: 'Save'}} cancel />
        </Form>

    </div>
}

export default Notifications;
